import React from 'react';
import {
  PricingPlanCard,
  PricingPlanCardLayout,
  PricingPlanCardProps,
} from './PricingPlanCard';
import {
  AnimatedDiv,
  ShowAnimation,
} from '@vimily/bonjoro-ui-components-v2/AnimatedDiv';
import cx from 'classnames';
import { BillingCycle } from '~/types/models';
import { ButtonVariant } from '@vimily/bonjoro-ui-components-v2/Button';

export interface PricingPlanCardsProps {
  className?: string;
  layout?: PricingPlanCardLayout;
  pricingPlanCards?: PricingPlanCardProps[];
  billingCycle?: BillingCycle;
  discounted?: boolean;
  ctaVariant?: ButtonVariant;
  hideCta?: boolean;
  hideBadge?: boolean;
  showImage?: boolean;
}

export function PricingPlanCards({
  className,
  pricingPlanCards,
  billingCycle,
  discounted,
  ctaVariant,
  layout,
  hideCta,
  hideBadge,
  showImage,
}: PricingPlanCardsProps) {
  return (
    <AnimatedDiv
      show
      showAnimation={ShowAnimation.SlideInDown150}
      className={cx(className, [
        'flex flex-col xs:flex-row gap-4 items-end justify-center',
      ])}
    >
      {pricingPlanCards?.map((planCard) => {
        return (
          <PricingPlanCard
            key={planCard.uid}
            {...planCard}
            ctaVariant={ctaVariant ?? planCard.ctaVariant}
            badge={!hideBadge ? planCard.badge : undefined}
            layout={layout}
            billingCycle={billingCycle}
            discounted={discounted}
            hideCta={hideCta}
            showImage={showImage}
          />
        );
      })}
    </AnimatedDiv>
  );
}
